import Checkbox from 'monday-ui-react-core/dist/Checkbox';
import AssignEmailControllers from './AssignEmailControllers';

const CheckboxControllers = ({
  t,
  selectedItem,
  addedFormFields,
  updateFormFields,
}) => {
  function handleCheckboxChange(e) {
    const isChecked = e.target.checked;
    selectedItem.required = isChecked;
    updateFormFields([...addedFormFields]);
  }

  return (
    <>
      <Checkbox
        label={t('Required')}
        checked={selectedItem?.required}
        onChange={handleCheckboxChange}
      />
      <AssignEmailControllers
        t={t}
        hideTipseen
        selectedItem={selectedItem}
        addedFormFields={addedFormFields}
        updateFormFields={updateFormFields}
      />
    </>
  );
};

export default CheckboxControllers;
